// Copyright (c) 2018 Deere & Company

import './update-amount-of-use.scss';
import React, {PropTypes} from 'react';
import AmountOfUseHistoryPanelBody from './amount-of-use-edit-modal/amount-of-use-history-panel-body';
import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import ModalHeaderCount from '../modal-header-with-count';
import Product from '@deere/cps-it.warranty-model-factory/lib/product';
import {WarrantyMediumModal} from '../../../shared/components/modal';

const UpdateAmountOfUseModal = props =>
    <WarrantyMediumModal
        className='amount-of-use-modal'
        isOpen={props.isModalOpen}
    >
        <ModalHeaderCount
            amountOfUseCount={props.amountOfUseHistory.length}
            modalTitle='AMOUNT_OF_USE_HISTORY_WITH_COUNT'
            onCloseButtonClick={props.onCloseButtonClick}
        />
        <AmountOfUseHistoryPanelBody
            actions={props.actions}
            amountOfUseHistory={props.amountOfUseHistory}
            onCloseButtonClick={props.onCloseButtonClick}
            product={props.product}
            updateAmountOfUseMeasurement={props.updateAmountOfUseMeasurement}
        />

    </WarrantyMediumModal>;

UpdateAmountOfUseModal.displayName = 'AmountOfUseModal';
UpdateAmountOfUseModal.propTypes = {
    actions: PropTypes.object,
    amountOfUseHistory: PropTypes.arrayOf(PropTypes.instanceOf(MeasurementReading)).isRequired,
    isModalOpen: PropTypes.bool.isRequired,
    onCloseButtonClick: PropTypes.func.isRequired,
    product: PropTypes.instanceOf(Product).isRequired,
    updateAmountOfUseMeasurement: PropTypes.instanceOf(MeasurementReading)
};

export default UpdateAmountOfUseModal;



// WEBPACK FOOTER //
// ./src/shared/components/amount-of-use-with-modal/update-amount-of-use.js